import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
    columnTypeEnum,
    calculatedColumnsEnum,
    alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import i18n from "@/plugins/vue-i18n.js";

export default {
    namespaced: true,
    state: {
        dimensionColumnsTables: [],
        measureColumnsTables: [],
        groupHeaders: [],
        defaultSortedColumnTables: "",
        tablesData: [],
        hideGroupsByTableNumber: {},
        dataReadyTables: false,
    },
    mutations: {
        setDimensionColumnsTables(state, data) {
            state.dimensionColumnsTables = data;
        },
        setMeasureColumnsTables(state, data) {
            state.measureColumnsTables = data;
        },
        setGroupHeaders(state, data) {
            state.groupHeaders = data;
        },
        setDefaultSortedColumnTables(state, data) {
            state.defaultSortedColumnTables = data;
        },
        setTablesData(state, data) {
            state.tablesData = data;
        },
        updateTableData(state, payload) {
            state.tablesData = state.tablesData.map(tab => {
                if (tab.tableHeaderId === payload.siteId) {
                    return { ...tab, dataTable: payload.dataTable, totalsData: payload.totalsData }
                }
                return tab;
            });
        },
        setHideGroupsByTableNumber(state, data) {
            state.hideGroupsByTableNumber = data;
        },
        updateHideGroupsByTableNumber(state, payload) {
            state.hideGroupsByTableNumber[payload.tableNumber] = payload.value;
        },
        setDataReadyTables(state, data) {
            state.dataReadyTables = data;
        },
    },
    actions: {
        resetDataReadyTables({ commit }) {
            commit("setDataReadyTables", false);
        },
        initDisplayTables({ commit }) {
            let dimensionColumnsTables = TableTools.Helper.constructColumnTable(
                [
                    dimensionEnum.SMARTTOUCH_NUMBER,
                    dimensionEnum.GAME_CODE,
                    dimensionEnum.GAME_NAME,
                ],
                null,
                columnTypeEnum.DIMENSION,
                true,
                null
            );

            let measureColumnsTables = TableTools.Helper.constructColumnTable(
                [
                    mesureEnum.VSMARTTOUCHMAINTENANCE_DURATION_SUM,
                    mesureEnum.VSMARTTOUCHMAINTENANCE_LAST_EVENT_DATE
                ],
                null,
                columnTypeEnum.MEASURE,
                true,
                null
            );

            commit("setDimensionColumnsTables", dimensionColumnsTables);

            commit("setMeasureColumnsTables", measureColumnsTables);

            commit("setGroupHeaders", []);

            commit("setDefaultSortedColumnTables", dimensionEnum.SMARTTOUCHMAINTENANCE_SERIAL_NUMBER);
        },
        async updateTableList({ commit }, payload) {
            // Initialisation des objets contenant toutes les données pour chaque site :
            // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
            const tablesData = payload.siteValues.map((site, i) => {
                return {
                    tableNumber: i.toString(),
                    tableHeader: site.label,
                    tableHeaderId: site.id,
                    dataTable: [],
                    totalsData: {},
                };
            });
            // Initialisation des lignes de catégories à cacher par défaut
            let hideGroupsByTableNumber = {};
            tablesData.forEach((table) => {
                hideGroupsByTableNumber[table.tableNumber] = true;
            });
            commit("setHideGroupsByTableNumber", hideGroupsByTableNumber);
            commit("setTablesData", tablesData);


            const query = {
                dimensions: [
                    dimensionEnum.SMARTTOUCH_NUMBER, 
                    dimensionEnum.GAME_CODE,
                    dimensionEnum.GAME_NAME,
                    dimensionEnum.SITE
                ],
                measures: [
                    mesureEnum.VSMARTTOUCHMAINTENANCE_DURATION_SUM,
                    mesureEnum.VSMARTTOUCHMAINTENANCE_LAST_EVENT_DATE
                ],
                filters: payload.filters,
            }
            const resultSets = await TableTools.Helper.doRequest(query)

            // Complétion des objets avec les données reçues pour chaque site
            payload.siteValues.forEach((site) => {
                let dataTable = resultSets.filter(
                    (result) => result[dimensionEnum.SITE] === site.id
                );

                commit("updateTableData", { siteId: site.id, dataTable });
            });
            commit("setDataReadyTables", true);
        },
        updateHideGroupsByTableNumber({ commit }, payload) {
            commit("updateHideGroupsByTableNumber", payload);
        },
    },
};